import React from "react"
import './styles/Footer.css'
function Footer(){

    return(
        <div className="footer-wrapper">
            <p className="footer-text">Phone: (773) 991 7798</p>
            <p className="footer-text">Email: alfonso25elorriaga@gmail.com</p>
            <p className="footer-text">Copyright © 2023 Alfonso SoftTech. All rights reserved.</p>
        </div>
    )
}

export default Footer